<template lang="pug">
  div
    v-select(
      :items="barrierNames"
      label="Select barrier type"
      @change="updateBarrierType"
      v-model="selected"
      solo
    )
    v-btn(
      block
      color="info"
      @click="addMarker()"
      :disabled="addBarrierText === 'Add Barrier'"
    ) {{ addBarrierText }}
    v-btn(
      block
      color="primary"
      :disabled="markers.length === 0"
      @click.native="showReviewDialog"
    ) {{ barrierOverview }}
</template>

<script>
import { mapGetters } from "vuex";
import availableBarrierTypes from "@/utilities/barrierTypes";
import Barrier from "@/utilities/barrier";

export default {
  name: "MapMenuAddBarrier",
  data() {
    return {
      addBarrierText: "Add Barrier",
      selected: "",
      barrierIcon: ""
    };
  },
  computed: {
    ...mapGetters(["getMapBounds", "mapCenter", "markers", "currentMarkerID"]),
    barrierNames: function() {
      return availableBarrierTypes.map(barrier => barrier.name);
    },
    barrierOverview: function() {
      return `Review barriers (${this.markers.length})`;
    },
    barrierIndex: function() {
      return availableBarrierTypes.findIndex(
        barrier => barrier.name === this.selected
      );
    }
  },
  methods: {
    showReviewDialog: function() {
      this.$store.dispatch("TOGGLE_REVIEW_DIALOG");
    },
    updateBarrierType: function(name) {
      this.addBarrierText = `Add ${name}`;
      this.barrierIcon = this.barrierIconURL;
    },
    addMarker: function() {
      // const currentBarrier = availableBarrierTypes[this.barrierIndex];
      const barrier = new Barrier(
        this.currentMarkerID,
        this.barrierIndex,
        `${this.selected} ${this.currentMarkerID}`,
        this.mapCenter,
        true
      );
      this.$store.dispatch("ADD_MARKER", barrier);
      this.$store.dispatch("INCREMENT_MARKER_ID");
    }
  }
};</script>
